import React, { useState, useEffect } from 'react';
import { 
  BarChart3, Users, Activity, FileText, TrendingUp, 
  X, Zap, Target
} from 'lucide-react';

interface ModernSidebarProps {
  currentView: string;
  setCurrentView: (view: string) => void;
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
}

const ModernSidebar: React.FC<ModernSidebarProps> = ({ 
  currentView, 
  setCurrentView, 
  sidebarOpen, 
  setSidebarOpen 
}) => {
  const navigationItems = [
    { key: 'overview', label: 'Vue d\'ensemble', icon: BarChart3, gradient: 'from-blue-500 to-cyan-500' },
    { key: 'users', label: 'Utilisateurs', icon: Users, gradient: 'from-purple-500 to-pink-500' },
    { key: 'sessions', label: 'Suivi Temps Réel', icon: Activity, gradient: 'from-green-500 to-emerald-500' },
    { key: 'tasks', label: 'Détails des tâches', icon: FileText, gradient: 'from-orange-500 to-red-500' },
    { key: 'totaltasks', label: 'Total Tasks', icon: Target, gradient: 'from-cyan-500 to-blue-500' },
    { key: 'reports', label: 'Rapports', icon: TrendingUp, gradient: 'from-indigo-500 to-purple-500' }
  ];

  return (
    <>
      {sidebarOpen && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <div className="fixed inset-0 bg-gray-900/80 backdrop-blur-sm" onClick={() => setSidebarOpen(false)} />
        </div>
      )}

      <div className={`fixed inset-y-0 left-0 z-50 w-64 sm:w-72 bg-white/90 backdrop-blur-xl border-r border-gray-200/50 transform transition-transform duration-200 ease-in-out lg:translate-x-0 lg:static lg:inset-0 ${
        sidebarOpen ? 'translate-x-0' : '-translate-x-full'
      }`}>
        <div className="flex h-14 sm:h-16 items-center justify-between px-4 sm:px-6 border-b border-gray-200/50">
          <span className="text-base sm:text-lg font-bold text-gray-900">Navigation</span>
          <button
            className="lg:hidden p-1 text-gray-500 hover:text-gray-700"
            onClick={() => setSidebarOpen(false)}
          >
            <X className="h-5 w-5 sm:h-6 sm:w-6" />
          </button>
        </div>

        <nav className="flex-1 px-3 sm:px-4 py-4 sm:py-6 space-y-2">
          {navigationItems.map(tab => {
            const IconComponent = tab.icon;
            const isActive = currentView === tab.key;
            
            return (
              <button
                key={tab.key}
                onClick={() => {
                  setCurrentView(tab.key);
                  setSidebarOpen(false);
                }}
                className={`w-full flex items-center px-3 sm:px-4 py-2 sm:py-3 text-sm font-semibold rounded-xl sm:rounded-2xl transition-all duration-200 group ${
                  isActive
                    ? `bg-gradient-to-r ${tab.gradient} text-white shadow-lg transform scale-105`
                    : 'text-gray-700 hover:bg-gray-100 hover:scale-105'
                }`}
              >
                <div className={`p-1.5 sm:p-2 rounded-lg sm:rounded-xl mr-2 sm:mr-3 ${
                  isActive 
                    ? 'bg-white/20' 
                    : `bg-gradient-to-r ${tab.gradient} text-white group-hover:scale-110 transition-transform`
                }`}>
                  <IconComponent className="w-4 h-4 sm:w-5 sm:h-5" />
                </div>
                <span className="text-xs sm:text-sm">{tab.label}</span>
                {isActive && (
                  <div className="ml-auto w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full animate-pulse"></div>
                )}
              </button>
            );
          })}
        </nav>
      </div>
    </>
  );
};

export default ModernSidebar;